import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { GrFormPrevious } from "react-icons/gr";
import { MdOutlineNavigateNext } from "react-icons/md";
import "../css/pagination.css";
import axios from "axios";
import { Server2 } from "../../redux/actions/auth/auth.actions";
import { useNavigate } from "react-router-dom";

const PER_PAGE = 25;

const FinancesMarketPlace = ({filter}) => {
  const navigate = useNavigate();
  const [Data, setData] = useState([]);
  const [Data2, setData2] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [accordian, setAccordian] = useState({state: false, index: null});

  function searchData() {

    return Data.filter((transaction) => {
      if (filter === "buyers") {
        return transaction?.is_buyer === true;
      }
      else if (filter === "sellers") {
        return transaction?.is_selling === true;
      }
      else {
        return transaction
      }
    });
  }
  const fetchTransactions = () => {
    var config = {
      method: "get",
      url: Server2 + "/admin/buyer-seller-summaries",
    };
    axios(config)
      .then(function (response) {
        setLoading(false);
        setData(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const fetchAllTransactions = () => {
    var config = {
      method: "get",
      url: Server2 + "/admin/financial-summaries",
    };
    axios(config)
      .then(function (response) {
        setLoading(false);
        setData2(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {	
    setLoading(true);
    fetchTransactions();
    fetchAllTransactions();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  //pagination function
  function handlePageClick({ selected: selectedPage }) {
    setCurrentPage(selectedPage);
  }

  //pagination
  const offset = currentPage * PER_PAGE;
  const currentPageData =
    Data.length === 0
      ? null
      : searchData()
          .slice(offset, offset + PER_PAGE)
          .map((transaction, index) => (
            <tbody key={index}>
              <tr>
                <td className="ps-2">
                  <div className="d-flex px-2 py-1 cursor-pointer" onClick={() => navigate(`/profile/${transaction?._id}`, { state: { item: transaction._id } })}>
                    <div>
                      <img
                        src={
                          transaction?.profile_pic
                            ? transaction?.profile_pic
                            : "/logoi192.png"
                        }
                        className="avatar avatar-sm me-3"
                        alt="user1"
                      />
                    </div>
                    <div className="d-flex flex-column justify-content-center align-items-stretch">
                      <h6 className="mb-0 text-sm text-capitalize ">
                        {transaction?.fname ? transaction?.fname : "iBouge"}
                      </h6>
                      <p className="text-xs text-secondary mb-0">
                        {transaction?.email}
                      </p>
                    </div>
                  </div>
                </td>
                { filter === 'buyers' ?
                <td className="align-middle text-center">
                  <p className="text-dark fw-bold">{Math.abs(transaction.totalIncoming?.toFixed(3))}</p>
                </td> 
                : filter === 'sellers' ?
                <td className="align-middle text-center">
                  <p className="text-dark fw-bold">{transaction.totalEarned?.toFixed(3)}</p>
                </td>
                : null
                }
                <td className="align-middle text-center">
                  <p className="text-dark fw-bold">{transaction.availableBalance?.toFixed(3)}</p>
                </td>
                <td className="align-middle text-center">
                  <p className="text-dark fw-bold">{transaction.withdrawnAmount?.toFixed(3)}</p>
                </td>
                { filter === 'buyers' ?
                <td className="align-middle text-center">
                  <p className="text-dark fw-bold">{transaction.buyerOrdersCount}</p>
                </td> 
                : filter === 'sellers' ?
                <td className="text-center">
                  <button
                    className="btn btn-sm btn-outline-secondary"
                    onClick={() => setAccordian({state: accordian.index === index ? !accordian.state : true, index: index})}
                    >
                    {accordian.state && accordian.index === index ? "▲" : "▼"}
                  </button>
                </td>
                : null
                }
              </tr>
              {/* Accordion Row */}
              {accordian.state && accordian.index === index && (
                <tr>
                  <td colSpan={6} className="bg-light p-3">
                    <div className="row g-3">
                      
                      <div className="col-md-3">
                        <div className="card shadow-sm">
                          <div className="card-body text-center">
                            <small className="text-muted">Platform Revenue</small>
                            <h6 className="fw-bold">{transaction.platformFeeAmount?.toFixed(3)}</h6>
                            <small className="text-muted"></small>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="card shadow-sm">
                          <div className="card-body text-center">
                            <small className="text-muted">Holding Balance</small>
                            <h6 className="fw-bold">{transaction.lockedAmount?.toFixed(3)}</h6>
                          </div>
                        </div>
                      </div>

                      {filter === 'sellers' &&
                      <div className="col-md-3">
                        <div className="card shadow-sm">
                          <div className="card-body text-center">
                            <small className="text-muted">Dispute Locked</small>
                            <h6 className="fw-bold">{transaction.disputedAmount?.toFixed(3)}</h6>
                          </div>
                        </div>
                      </div>
                      }

                      {filter === 'buyers' &&
                      <div className="col-md-3">
                        <div className="card shadow-sm">
                          <div className="card-body text-center">
                            <small className="text-muted">Refundable</small>
                            <h6 className="fw-bold">{transaction.refundableAmount?.toFixed(3)}</h6>
                          </div>
                        </div>
                      </div>
                      }

                      {filter === 'buyers' &&
                      <div className="col-md-3">
                        <div className="card shadow-sm">
                          <div className="card-body text-center">
                            <small className="text-muted">Total Orders</small>
                            <h6 className="fw-bold">{transaction.buyerOrdersCount}</h6>
                          </div>
                        </div>
                      </div>
                      }

                      {filter === 'sellers' &&
                      <div className="col-md-3">
                        <div className="card shadow-sm">
                          <div className="card-body text-center">
                            <small className="text-muted">Total Orders</small>
                            <h6 className="fw-bold">{transaction.sellerOrdersCount}</h6>
                          </div>
                        </div>
                      </div>
                      }

                      {/* <div className="col-md-3">
                        <div className="card shadow-sm">
                          <div className="card-body d-flex flex-column align-items-center">
                            <div className="d-flex gap-2">
                              <small className="text-muted">Is Buyer</small>
                              <h6 className="fw-bold">{transaction.is_buyer.toString()}</h6>
                            </div>
                            <div className="d-flex gap-2">
                              <small className="text-muted">Is Seller</small>
                              <h6 className="fw-bold mb-0 pb-0">{transaction.is_selling.toString()}</h6>
                            </div>
                          </div>
                        </div>
                      </div> */}

                      {/* <div className="col-md-3">
                        <div className="card shadow-sm">
                          <div className="card-body d-flex flex-column align-items-center">
                            <div className="d-flex gap-2">
                              <small className="text-muted">Orders Placed</small>
                              <h6 className="fw-bold">{transaction.buyerOrdersCount}</h6>
                            </div>
                            <div className="d-flex gap-2">
                              <small className="text-muted">Orders Got</small>
                              <h6 className="fw-bold mb-0 pb-0">{transaction.sellerOrdersCount}</h6>
                            </div>
                          </div>
                        </div>
                      </div> */}

                      {/* <div className="col-md-3">
                        <div className="card shadow-sm">
                          <div className="card-body text-center d-flex justify-content-evenly">
                            <div className="">
                              <small className="text-muted">Orders Placed</small>
                              <h6 className="fw-bold">{transaction.buyerOrdersCount}</h6>
                            </div>
                            <div className="">
                              <small className="text-muted">Orders Got</small>
                              <h6 className="fw-bold">{transaction.sellerOrdersCount}</h6>
                            </div>
                          </div>
                        </div>
                      </div> */}

                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          ));

  const pageCount = Math.ceil(searchData().length / PER_PAGE);

  return (
    <>
      {loading ? (
        <div className="d-flex justify-content-center align-items-center">
          <div
            className="spinner-border"
            role="status"
            style={{ width: "6rem", height: "6rem", color: "#6148A1" }}
          >
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      ) : (
        <>
          <div className="container-fluid ">
            <div className="row">
              <div className="col-12">
                <div className="card mb-4">
                  <div className="card-header pb-0">
                    <h6>Financial Summaries</h6>
                  </div>
                  <div
                    className="card-body px-0 pt-0 pb-2 task"
                    style={{ height: "73vh", overflow: "auto" }}
                  >
                    <div className="table-responsive p-0">

                      {/* Cards */}
                      <div className="row g-3 px-3 mb-3">

                        <div className="col-md-2">
                          <div className="card shadow-sm" style={{backgroundColor: '#6148a1', color: 'white', height: 105}}>
                            <div className="card-body text-center">
                              <small className="">Total Income</small>
                              <h6 className="fw-bold mb-n1">{Math.abs(Data2.totalIncoming?.toFixed(3))}</h6>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-2">
                          <div className="card shadow-sm" style={{backgroundColor: '#6148a1', color: 'white', height: 105}}>
                            <div className="card-body text-center">
                              <small className="">Platform Revenue</small>
                              <h6 className="fw-bold">{Data2.platformFeeAmount?.toFixed(3)}</h6>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-2">
                          <div className="card shadow-sm" style={{backgroundColor: '#6148a1', color: 'white', height: 105}}>
                            <div className="card-body text-center">
                              <small className="">Seller Payables</small>
                              <h6 className="fw-bold">{Data2.payableBalance?.toFixed(3)}</h6>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-2">
                          <div className="card shadow-sm" style={{backgroundColor: '#6148a1', color: 'white', height: 105}}>
                            <div className="card-body text-center">
                              <small className="">Refundables</small>
                              <h6 className="fw-bold">{Data2.refundableAmount?.toFixed(3)}</h6>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-2">
                          <div className="card shadow-sm" style={{backgroundColor: '#6148a1', color: 'white', height: 105}}>
                            <div className="card-body text-center">
                              <small className="">Total Paid</small>
                              <h6 className="fw-bold">{Data2.payoutAmounts?.toFixed(3)}</h6>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-2">
                          <div className="card shadow-sm" style={{backgroundColor: '#6148a1', color: 'white', height: 105}}>
                            <div className="card-body d-flex flex-column align-items-center">
                              <div className="d-flex gap-2">
                                <small className="">Total Orders</small>
                                <h6 className="fw-bold">{Data2.totalOrders}</h6>
                              </div>
                              <div className="d-flex gap-2">
                                <small className="">Paid Orders</small>
                                <h6 className="fw-bold mb-0 pb-0">{Data2.paidOrders}</h6>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* <div className="col-md-2">
                          <div className="card shadow-sm" style={{backgroundColor: '#6148a1', color: 'white', height: 105}}>
                            <div className="card-body d-flex flex-column align-items-center">
                              <div className="d-flex gap-2">
                                <small className="">Buyers</small>
                                <h6 className="fw-bold">{Data2.buyers}</h6>
                              </div>
                              <div className="d-flex gap-2">
                                <small className="">Sellers</small>
                                <h6 className="fw-bold mb-0 pb-0">{Data2.sellers}</h6>
                              </div>
                            </div>
                          </div>
                        </div> */}

                      </div>


                      <table className="table align-items-center mb-0">
                        <thead>
                          <tr>
                            <th className="text-uppercase">Users</th>
                            { filter === 'buyers' ? 
                            <th className="text-uppercase text-center">Buyer Spendings</th>
                            : filter === 'sellers' ?
                            <th className="text-uppercase text-center">Seller Earnings</th>
                            : null
                            }                            
                            <th className="text-uppercase text-center">Available Balance</th>
                            <th className="text-uppercase text-center">Total Withdrawn</th>
                            { filter === 'buyers' ? 
                            <th className="text-uppercase text-center">Total Orders</th>
                            : filter === 'sellers' ?
                            <th className="text-uppercase text-center">Action</th>
                            : null
                            }
                          </tr>
                        </thead>
                        {currentPageData}
                      </table>
                    </div>

                    {searchData().length > 24 ? (
                      <div
                        className=" mt-4"
                        style={{
                          padding: 2,
                          boxSizing: "border-box",
                          width: "100%",
                        }}
                      >
                        <ReactPaginate
                          activeClassName={"item active "}
                          breakClassName={"item break-me "}
                          breakLabel={"..."}
                          containerClassName={"pagination"}
                          t
                          disabledClassName={"disabled-page"}
                          marginPagesDisplayed={2}
                          nextClassName={"item next "}
                          nextLabel={
                            <MdOutlineNavigateNext
                              style={{ fontSize: 18, width: 150 }}
                            />
                          }
                          onPageChange={handlePageClick}
                          pageCount={pageCount}
                          pageClassName={"item pagination-page "}
                          pageRangeDisplayed={2}
                          previousClassName={"item previous"}
                          previousLabel={
                            <GrFormPrevious
                              style={{ fontSize: 18, width: 150 }}
                            />
                          }
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default FinancesMarketPlace;